import type { InvoicingSettingsValuesPatch } from '../../../writer'
import type { ComplianceSettingsFormValues } from '../types/complianceSettingsFormValues'

// The writer merges `legalFormSettings` and `legalMentions.custom` key by key, so the keys left out
// here keep their cached values.
export const getCompliancePayload = (values: ComplianceSettingsFormValues): InvoicingSettingsValuesPatch => {
  const { legalFormSettings, legalMentions } = values

  return {
    company: {
      legalFormSettings,
      legalMentions,
    },
  }
}
